import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

export const HeaderNav = () => {
    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const closeMenu = () => {
        setMenuOpen(false);
    };

    return (
        <header className='header'>
            <div className='logo'>
                <NavLink to="/inicio" onClick={closeMenu}>
                    <div className="logo-icon">
                        <svg width="45" height="45" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="10" y="10" width="50" height="50" rx="12" fill="url(#logo-grad)" />
                            <rect x="40" y="40" width="50" height="50" rx="12" fill="url(#logo-grad)" fillOpacity="0.5" />
                            <rect x="25" y="25" width="50" height="50" rx="12" stroke="white" strokeWidth="6" />
                            <defs>
                                <linearGradient id="logo-grad" x1="10" y1="10" x2="90" y2="90" gradientUnits="userSpaceOnUse">
                                    <stop stopColor="#fa4529" />
                                    <stop offset="1" stopColor="#ff7e5f" />
                                </linearGradient>
                            </defs>
                        </svg>
                    </div>
                    <div className="logo-text">
                        <span className="name">Michael Cuadros</span>
                        <span className="tagline">Ingeniero de Sistemas de Información</span>
                    </div>
                </NavLink>
            </div>

            <button className={`menu-toggle ${menuOpen ? 'open' : ''}`} onClick={toggleMenu} aria-label="Menu">
                <span></span>
                <span></span>
                <span></span>
            </button>

            <nav className={menuOpen ? 'nav-open' : ''}>
                <ul>
                    <li>
                        <NavLink
                            className={({ isActive }) => isActive ? "active" : ""}
                            to="/inicio"
                            onClick={closeMenu}
                        >Inicio</NavLink>
                    </li>
                    <li>
                        <NavLink
                            className={({ isActive }) => isActive ? "active" : ""}
                            to="/portafolio"
                            onClick={closeMenu}
                        >Portafolio</NavLink>
                    </li>
                    <li>
                        <NavLink
                            className={({ isActive }) => isActive ? "active" : ""}
                            to="/servicios"
                            onClick={closeMenu}
                        >Servicios</NavLink>
                    </li>
                    <li>
                        <NavLink
                            className={({ isActive }) => isActive ? "active" : ""}
                            to="/contacto"
                            onClick={closeMenu}
                        >Contacto</NavLink>
                    </li>
                </ul>
            </nav>
        </header>
    );
};
